function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9E9",
  fillRule: "evenodd",
  d: "M8.19231 9.61818C9.99427 9.61818 11.4551 8.13665 11.4551 6.30909C11.4551 4.48153 9.99427 3 8.19231 3C6.39034 3 4.92956 4.48153 4.92956 6.30909C4.92956 8.13665 6.39034 9.61818 8.19231 9.61818ZM16.0833 6.74692V4.80303H14.5833V6.74692H12.6667V8.26823H14.5833V10.2121H16.0833V8.26823H18V6.74692H16.0833ZM5.15456 10.6909C3.41234 10.6909 2 12.1032 2 13.8454C2 15.5877 3.41235 17 5.15456 17H11.3945C13.1367 17 14.549 15.5877 14.549 13.8454C14.549 12.1032 13.1367 10.6909 11.3945 10.6909H5.15456Z",
  clipRule: "evenodd"
});

function SvgInviteUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteUsers);
export default __webpack_public_path__ + "static/media/invite-users.e1cf204b.svg";
export { ForwardRef as ReactComponent };